import { alpha } from '@mui/material';
import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var ChipTheme = function (theme) {
    var _a;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: function (_a) {
                var _b;
                var ownerState = _a.ownerState;
                return ({
                    '.MuiChip-label': (_b = {
                            fontSize: theme.typography.body3.fontSize
                        },
                        _b[breakpoints.down('sm')] = {
                            fontSize: "0.688rem", //11
                        },
                        _b['+ svg'] = {
                            marginRight: 8,
                        },
                        _b),
                    '&.Mui-disabled': {
                        opacity: 1,
                        '&.MuiChip-filled ': {
                            color: alpha(theme.palette.greySecondary.main, 0.48),
                            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                        },
                        '&.MuiChip-outlined': {
                            color: alpha(theme.palette.greySecondary.main, 0.48),
                            borderColor: theme.palette.greySecondary.light,
                            backgroundColor: theme.palette.common.white,
                        },
                    },
                });
            },
            deleteIcon: (_a = {
                    // color: theme.palette.greySecondary[400],
                    fontSize: theme.typography.body3.fontSize
                },
                _a[breakpoints.down('sm')] = {
                    fontSize: "0.688rem", //11
                },
                _a),
        },
    });
};
export default ChipTheme;
//# sourceMappingURL=theme.js.map